import React, { useEffect, useState } from 'react';

import { Container } from 'react-bootstrap';
import {  apiUrl, curationApiUrl } from "../config/default";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Alert from '@mui/material/Alert';
import { tissueTranslate, relTissueTranslate, backboneTranslate, allelicBasisTranslate} from './dictionaries';
import CircularProgress from '@mui/material/CircularProgress';

import EmbryoImage from './embryo-image';
import AllelicCurationCoordinateViewer from './allelic-curation-coordinate-viewer';
import "../css/image-browser-table.css";


export default function AllelicCurationBrowser(props: any) {
    const [allelicCurationData, setAllelicCurationData] = useState<any>([]);
    const [isReady, setIsReady] = React.useState(false);
  
    useEffect(() => {
        let inputData = props.data;
        if(!inputData["refId"] || !inputData["altId"]|| !inputData["refExp"] || !inputData["altExp"]) {
            return;
        }

        
        let refIdentifiers = inputData["refId"].split(".");
        let refVistaId = refIdentifiers[0];
        let refAlleleId = Number(refIdentifiers[1]);
        let altIdentifiers = inputData["altId"].split(".");
        let altVistaId = altIdentifiers[0];
        let altAlleleId = Number(altIdentifiers[1]);       
        let refExp = inputData["refExp"];
        let altExp = inputData["altExp"];

        const refEntryUrl = apiUrl + "/catalogs/externalElementPage?vistaId=" + refVistaId + "&alleleId=" + refAlleleId;
        const altEntryUrl = apiUrl + "/catalogs/externalElementPage?vistaId=" + altVistaId + "&alleleId=" + altAlleleId;
        const refUrl = curationApiUrl + "/EmbryoImages/externalImages?container=" + refExp;
        const altUrl = curationApiUrl + "/EmbryoImages/externalImages?container=" + altExp;

        const fetchData = async () => {
            //first API call: the reference entry and retrieving the main data
            const refCurationApiContentResult =  await fetch(refEntryUrl)
                                      .then(res => res.json());
            if(refCurationApiContentResult && refCurationApiContentResult.data) {
                let curation_data: any = [];
                let refImages: any[] = [];
                let altImages: any[] = [];
                let content = refCurationApiContentResult.data.find((item:any)=>{
                    return item.vista_id===refVistaId && item.allele_id===refAlleleId && item.exp_hier === refExp;
                  });
            for(let i =0; i< content["allelic_curation"].length; i+=1) {
                let row = content["allelic_curation"][i];
                if(row["refExp"] === refExp && row["altExp"] === altExp) {
                    curation_data = row;
                    break;
                }
            }
            curation_data["ref_expression"] = content["curation_status"];
            curation_data["ref_stage"] = content["stage"];
            curation_data["ref_backbone"] = content["backbone"];
            curation_data["ref_organism"] = content["organism"];
            curation_data["ref_assembly"] = content["assembly"];
            curation_data["ref_coord"] = content["coord"];
            curation_data["ref_coord_hg38"] = content["coordinate_hg38"];
            curation_data["ref_coord_mm10"] = content["coordinate_mm10"];
            curation_data["ref_seq"] = content["seq"];
            curation_data["ref_seq_hg38"] = content["seq_hg38"];
            curation_data["ref_seq_mm10"] = content["seq_mm10"];
            curation_data["ref_description"] = content["description"];
            curation_data["ref_tissue"] = content["tissue"];
            //second API call: the alternate entry
            const altApiContentResult =  await fetch(altEntryUrl)
                                      .then(res => res.json());
            if(altApiContentResult && altApiContentResult.data) {
                let content = altApiContentResult.data.find((item:any)=>{
                    return item.vista_id===altVistaId && item.allele_id===altAlleleId && item.exp_hier === altExp;
                  });
                curation_data["alt_expression"] = content["curation_status"];
                curation_data["alt_stage"] = content["stage"];
                curation_data["alt_backbone"] = content["backbone"];
                curation_data["alt_organism"] = content["organism"];
                curation_data["alt_assembly"] = content["assembly"];
                curation_data["alt_coord"] = content["coord"];
                curation_data["alt_coord_hg38"] = content["coordinate_hg38"];
                curation_data["alt_coord_mm10"] = content["coordinate_mm10"];
                curation_data["alt_seq"] = content["seq"];
                curation_data["alt_seq_hg38"] = content["seq_hg38"];
                curation_data["alt_seq_mm10"] = content["seq_mm10"];
                curation_data["alt_description"] = content["description"];
                curation_data["alt_tissue"] = content["tissue"];
            }
            //third API call: the refExp images
            const refExpApiResult = await fetch(refUrl)
                                            .then(res => res.json());
            if(refExpApiResult && refExpApiResult.data && refExpApiResult.data.length>0) {
                let images = refExpApiResult;
                
                  for(let i=0; i < images.data.length; i+=1) {

                    refImages.push(
                      { "exp_embryo":images.data[i].metadata["exp_embryo"],  
                      "exp_hier":images.data[i].metadata["exp_hier"], 
                      "genotype":images.data[i].metadata["genotype"], 
                      "image":images.data[i].metadata["image"], 
                      "is_blue":images.data[i].metadata["is_blue"], 
                      "img_hier":images.data[i].metadata["img_hier"],
                      "sections_link":images.data[i].metadata["sections_link"],
                      //"img_path":images.data[i].metadata["img_path"]
                                    }
                    );
                  }
            }
            //fourth API call: the altExp images
            const altExpApiResult = await fetch(altUrl)
                                            .then(res => res.json());
            if(altExpApiResult && altExpApiResult.data && altExpApiResult.data.length>0) {
                let images = altExpApiResult;
                
                  for(let i=0; i < images.data.length; i+=1) {

                    altImages.push(
                        { "exp_embryo":images.data[i].metadata["exp_embryo"],  
                            "exp_hier":images.data[i].metadata["exp_hier"], 
                            "genotype":images.data[i].metadata["genotype"], 
                            "image":images.data[i].metadata["image"], 
                            "is_blue":images.data[i].metadata["is_blue"], 
                            "img_hier":images.data[i].metadata["img_hier"],
                            "sections_link":images.data[i].metadata["sections_link"],
                            //"img_path":images.data[i].metadata["img_path"]
                                          }
                    );
                  }
            }
            curation_data["ref_images"] = refImages;
            curation_data["alt_images"] = altImages;
            
            if(curation_data["backbone"] !== "-") {
                curation_data["alt_backbone"] = curation_data["backbone"];
            }
            else {
                curation_data["alt_backbone"] = curation_data["ref_backbone"];
            }
            curation_data["refId"] = inputData["refId"];
            curation_data["altId"] = inputData["altId"];
            setAllelicCurationData(curation_data);
            setIsReady(true);
            }
            else {
                setAllelicCurationData(null);
                setIsReady(true);
            }
        }


        fetchData()
        .catch((error)=>{
          console.log("Error when fetch element data: ",error);
        });

    }, [props.data]);


    const updateExperimentTitlePage = () => {
        // After successful API call: update page title to include element info
        document.title = allelicCurationData["refId"] + " - "  + allelicCurationData["altId"] + " Comparison - Vista Enhancer Browser"; 
      }


    const existsGenotypeInImages = (genotype:any) => {
        var exists: boolean = false;
        for(let i=0; i < allelicCurationData["ref_images"].length; i+=1) {
            if(allelicCurationData["ref_images"][i].genotype === genotype) {
                exists = true;
                break;
            }
        }
        for(let i=0; i < allelicCurationData["alt_images"].length; i+=1) {
            if(allelicCurationData["alt_images"][i].genotype === genotype) {
                exists = true;
                break;
            }
        }
        return(exists);
    };

    const groupImagesByGenotype = (allelicCurationData:any[], genotype:any, key:any) => {
        if(!allelicCurationData[key]) {
            return null;
        }
        let listed: any = [];
        for(let i=0; i < allelicCurationData[key].length; i+=1) {
            let imgItem = allelicCurationData[key][i];
            let keep_tissue = false;
            
            //if(genotype !== null) {
                if(imgItem.genotype === genotype) {
                    keep_tissue = true;
                }
                else {
                    keep_tissue = false
                }
            //}
            //else if(genotype === null) {
             //   keep_tissue = true;
            //}
            //else {
            //    continue;
            //}
            if (keep_tissue === true) {
                listed.push({embryo: imgItem.exp_embryo, item: imgItem});
            }
        }
        listed.sort(function(a:any,b:any) {return a.embryo - b.embryo||a.image - b.image});
        let html_obj: any[] = []
        for(let i=0; i < listed.length; i+=1) {
            let imgItem = listed[i].item;
            html_obj.push(
                <EmbryoImage imgItem={imgItem}></EmbryoImage>
            )   
        }
        return(
            <div>
                {html_obj}
            </div>
           )  
    };



    const imageComparisonBrowserByGenotype = () => {
        let genotypes: any[] = [];
        if(allelicCurationData.allelic_basis === null || allelicCurationData.allelic_basis === "all_tg") {
            genotypes = ["tandem", "single", "random", "none", null];
        }
        else {
            if( allelicCurationData.allelic_basis === "T" ) {
                genotypes = ["tandem"];
            }
            if(allelicCurationData.allelic_basis === "T+S") {
                genotypes = ["tandem", "single"];
            }
        }
        let browserRows: any[] = [];
        genotypes.forEach(function(genotype:any){
            if(existsGenotypeInImages(genotype)){
            let genotype_str = "undetermined";
            if(genotype !== null) {
                genotype_str = genotype;
            }
            browserRows.push(
                <TableRow style={{"verticalAlign": "top"}}>
                     <TableCell><b>{genotype_str}</b></TableCell>
                     <TableCell>
                        {groupImagesByGenotype(allelicCurationData, genotype, "ref_images")}
                    </TableCell>
                    <TableCell> 
                        {groupImagesByGenotype(allelicCurationData, genotype, "alt_images")}
                    </TableCell>
                </TableRow>
            )
        }
        });

        return(
            <Table>
            <TableHead style={{"backgroundColor":"#8fb5ba"}}>
                <TableRow>
                    <TableCell style={{"width":"10%"}}>Genotype</TableCell>
                    <TableCell style={{"width":"45%"}}>Reference</TableCell>
                    <TableCell style={{"width":"45%"}}>Alternate</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {browserRows}
            </TableBody>
        </Table>

        )

    };


    const tissueBrowser = () => {
        if(!allelicCurationData.rel_tissue)
            return null;
        if(allelicCurationData["explicit"] === "FALSE" || allelicCurationData["explicit"] === 0)
            return null;
        let tissues: any[] = allelicCurationData.rel_tissue.split(";");
        let tissue_values: any[] = allelicCurationData.rel_tissue_value.split(";");

        let tissues_row: any[] = [];
        let values_row: any[] = [];
        for(let i=0; i < tissues.length; i+=1) {
            tissues_row.push(
                <TableCell>{tissueTranslate(tissues[i], "label")}</TableCell>
                );
            values_row.push(
                <TableCell>{relTissueTranslate(tissue_values[i])}</TableCell>
                );
        }

        return(
            <Table>
                <TableHead style={{"backgroundColor":"#8fb5ba"}}>
                    <TableRow>
                        <TableCell colSpan={tissues.length + 1}>Comparative curation of tissues</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell style={{width:"15%"}}><b>Tissue</b></TableCell>{tissues_row}
                    </TableRow>
                    <TableRow>
                        <TableCell style={{width:"15%"}}><b>Experiment Effect</b></TableCell>{values_row}
                    </TableRow>
                </TableBody>
            </Table>
        )
    };


    const allelicBasisRender = () => {
        if(!allelicCurationData["allelic_basis"])
            return(<span>None</span>)
        
        return(<span>{allelicBasisTranslate(allelicCurationData["allelic_basis"])} ({allelicCurationData["allelic_basis"]})</span>)
    }

    const experimentPagelink =(type:string) => {
        let elementId, vistaId, alleleId, stage, backbone, id_components: any[]; 
        if(type === "ref") {
            elementId = allelicCurationData["refId"];
            id_components = allelicCurationData["refId"].split(".");
            vistaId = id_components[0];
            alleleId = id_components[1];
            stage = allelicCurationData["ref_stage"];
            backbone = allelicCurationData["ref_backbone"];
            
        }
        else {
            elementId = allelicCurationData["altId"];
            id_components = allelicCurationData["altId"].split(".");
            vistaId = id_components[0];
            alleleId = id_components[1];
            stage = allelicCurationData["alt_stage"];
            backbone = allelicCurationData["alt_backbone"];
        }
        let url = "element?vistaId="+ vistaId +"&alleleId=" + alleleId +"&backbone=" + backbone + "&stage=" + stage;
        return(
            <a href={url} className='text-decoration-none'>{elementId}</a>
        )
        
    }
    
    const revCompLink = () => {
        if(allelicCurationData["revcomp"] !== "TRUE" && allelicCurationData["revcomp"] !== 1) {
            return null;
        }
        let rev_url = 'curation?refId=' + allelicCurationData['altId'] + '&altId=' + allelicCurationData['refId'] + '&refExp=' + allelicCurationData['altExp'] + '&altExp=' + allelicCurationData['refExp'];
        return(
            <div className='my-1'>
            <span className='align-middle'>Note: this page shows the reverse complement of an allelic comparison. To view the original comparison, click on this button:</span>
            <a href={rev_url} className='btn btn-sm btn-primary float-end'>
                <b>View Original Comparison</b>
            </a>
            </div>
        );
    }

    const renderExpressionBadge = (expression:String) => {
        if(!allelicCurationData)
            return null;

        let circleColor= "orange";
        let pretty = "curated allele";
        let textColor = "black";
        if(expression === "positive") {
            circleColor= "blue";
            pretty = "positive";
            textColor = "white";
        }
        else if(expression === "curated") {
            circleColor = "orange";
            pretty = "curated allele";
            textColor = "black";
        }
        else if(expression === "negative") {
            circleColor= "grey";
            pretty = "negative";
            textColor = "white"
        }
        else {
            circleColor = "orange";
            pretty = "curated allele";
            textColor = "black";
        }
        return(
            <div className="p-button p-button-rounded" style={{"backgroundColor":circleColor, "color": textColor, textDecoration: "none"}}>
                  {pretty}
                </div> 
        )
    }

    const manuallyCuratedAnnotationData = () => {
        if(!allelicCurationData)
            return null;
        if(allelicCurationData["explicit"] === "FALSE"|| allelicCurationData["explicit"] === 0)
            return null;

        return(
            <TableRow>
                    <TableCell><b>Number of embryos</b></TableCell>
                    <TableCell>{allelicCurationData["ref_denom"]}</TableCell>
                    <TableCell> {allelicCurationData["alt_denom"]}</TableCell>
                </TableRow>
        )
    };

    const prepareAlignmentViewer = () => {
        if(!allelicCurationData)
            return null;
        let refData = {
            vista_id: allelicCurationData["refId"].split(".")[0],
            allele_id: allelicCurationData["refId"].split(".")[1],
            stage: allelicCurationData["ref_stage"],
            backbone: allelicCurationData["ref_backbone"],
            curation_status: allelicCurationData["ref_expression"],
            coord: allelicCurationData["ref_coord"],
            coordinate_hg38: allelicCurationData["ref_coord_hg38"],
            coordinate_mm10: allelicCurationData["ref_coord_mm10"],
            assembly: allelicCurationData["ref_assembly"],
            tissue: allelicCurationData["ref_tissue"],
            exp_hier: allelicCurationData["refExp"]
        };

        let altData = {
            vista_id: allelicCurationData["altId"].split(".")[0],
            allele_id: allelicCurationData["altId"].split(".")[1],
            stage: allelicCurationData["alt_stage"],
            backbone: allelicCurationData["alt_backbone"],
            curation_status: allelicCurationData["alt_expression"],
            coord: allelicCurationData["alt_coord"],
            coordinate_hg38: allelicCurationData["alt_coord_hg38"],
            coordinate_mm10: allelicCurationData["alt_coord_mm10"],
            assembly: allelicCurationData["alt_assembly"],
            tissue: allelicCurationData["alt_tissue"],
            exp_hier: allelicCurationData["altExp"]
        };
        console.log(refData)
        return(
            <AllelicCurationCoordinateViewer referenceData={refData} alternateData={altData}></AllelicCurationCoordinateViewer>
        )
    };

    
    if(!allelicCurationData || allelicCurationData.length === 0) {
        if(!isReady) {
          return(<>
          
          <div style={{minHeight:"70vh", background:"white",opacity:"1.0",zIndex: 100,position: 'fixed', top: 0,right: 0,bottom: 0,left: 0}}>
            <CircularProgress
                variant="indeterminate"
                disableShrink 
                size={100}
                sx={{ 
                    position: 'absolute',
                    marginLeft: "auto",
                    marginRight: "auto",
                    left: 0,
                    right: 0,
                    top:"50%",
                    textAlign: "center",
                    zIndex: 111
                }}
            /> 
            </div>
            
            <Alert severity="info" style={{margin:"20vh 0 auto 0"}}>
                  <b>Loading page contents...</b>
                </Alert>
            
          
          </>);
        }
        else {
        return (
                <> 
                <Alert severity="info" style={{margin:"20vh 0 auto 0"}}>
                  <b>No match found for your search!</b>
                </Alert>
                </>
                );
              }
      }
    return (
    <div>
        {updateExperimentTitlePage()}
        <h4 style={{"color":"#aaa"}}>Experiment Comparison /</h4>
        <h1>{allelicCurationData["refId"]} vs {allelicCurationData["altId"]}</h1>
        
        <Container>
        <h3>Overview</h3>
        <Table>
            <TableHead style={{"backgroundColor":"#8fb5ba"}}>
            <TableRow>
                    <TableCell colSpan={3}><b>Element Information</b></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell><b>Element ID</b></TableCell>
                    <TableCell>{experimentPagelink("ref")}</TableCell>
                    <TableCell>{experimentPagelink("alt")}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell><b>Organism</b></TableCell>
                    <TableCell>{allelicCurationData["ref_organism"]}</TableCell>
                    <TableCell>{allelicCurationData["alt_organism"]}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell><b>Element Description</b></TableCell>
                    <TableCell>{allelicCurationData["ref_description"]}</TableCell>
                    <TableCell>{allelicCurationData["alt_description"]}</TableCell>
                </TableRow>
                <TableRow>
                <TableCell><b>Expression</b></TableCell>
                    <TableCell>{renderExpressionBadge(allelicCurationData["ref_expression"])}</TableCell>
                    <TableCell>{renderExpressionBadge(allelicCurationData["alt_expression"])}</TableCell>
                </TableRow>
                <TableRow>
                <TableCell><b>Stage</b></TableCell>
                    <TableCell>{allelicCurationData["ref_stage"]}</TableCell>
                    <TableCell>{allelicCurationData["alt_stage"]}</TableCell>
                </TableRow>
                <TableRow>
                <TableCell><b>Backbone</b></TableCell>
                    <TableCell>{allelicCurationData["ref_backbone"]}</TableCell>
                    <TableCell>{allelicCurationData["alt_backbone"]}</TableCell>
                </TableRow>
                <TableRow>
                <TableCell><b>Promoter</b></TableCell>
                    <TableCell>{backboneTranslate(allelicCurationData["ref_backbone"], "promoter")}</TableCell>
                    <TableCell>{backboneTranslate(allelicCurationData["alt_backbone"], "promoter")}</TableCell>
                </TableRow>
                <TableRow>
                <TableCell><b>Transgenesis</b></TableCell>
                    <TableCell>{backboneTranslate(allelicCurationData["ref_backbone"], "transgenesisType")}</TableCell>
                    <TableCell>{backboneTranslate(allelicCurationData["alt_backbone"], "transgenesisType")}</TableCell>
                </TableRow>
                {manuallyCuratedAnnotationData()}
            </TableBody>
        </Table>
        </Container>
        <br />
        <Container>
        <Table>
            <TableHead style={{"backgroundColor":"#8fb5ba"}}>
                <TableRow>
                    <TableCell colSpan={2}><b>Curation Details</b></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
            <TableRow>
                    <TableCell><b>Comparison Type</b></TableCell>
                    <TableCell >{allelicCurationData["rel_comparison"]}</TableCell>
                </TableRow>
            <TableRow>
                    <TableCell><b>Comparison Basis</b></TableCell>
                    <TableCell >{allelicBasisRender()}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell><b>External Note</b></TableCell>
                    <TableCell >{(allelicCurationData["ext_allelic_note"] !== null)? allelicCurationData["ext_allelic_note"] : "None"}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell><b>Manually Curated?</b></TableCell>
                    <TableCell >{(allelicCurationData["explicit"] === "TRUE"|| allelicCurationData["explicit"] === 1)? "Yes" : "No"}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell><b>Reverse Comparison?</b></TableCell>
                    <TableCell >{(allelicCurationData["revcomp"] === "TRUE" || allelicCurationData["revcomp"] === 1)? "Yes" : "No"}</TableCell>
                </TableRow>
            </TableBody>
        </Table>
        {revCompLink()}
        </Container>
        <br/>
        {tissueBrowser()}
        <br /> 
        <br />
        
        <Container>
        <h3>Embryo Comparison</h3>
        {imageComparisonBrowserByGenotype()}

        {/* {prepareAlignmentViewer()} */}
        </Container>
    </div>
    )
}